module.exports = __webpack_public_path__ + "img/43.9.TU.911c4886.png";